import { Sector } from "../types";

export const getScopedSectors = (
  sectors: Sector[] | undefined,
  segmentId?: string | null
) => {
  if (!sectors?.length) return [];
  if (!segmentId) return sectors;

  return sectors.filter((sector) => sector.id === segmentId);
};

export const shouldShowSectorOthers = (segmentId?: string | null) =>
  !segmentId;

export const getDefaultSectorId = (
  sectors: Sector[] | undefined,
  segmentId?: string | null
) => {
  if (segmentId) return segmentId;
  if (!sectors?.length) return "";

  return [...sectors].sort((a, b) => a.name.localeCompare(b.name))[0].id;
};

export const matchesSectorScope = (
  segment: { id?: string } | undefined,
  sectorId: string,
  segmentId?: string | null
) => {
  if (segmentId) {
    return segment?.id === segmentId;
  }

  if (sectorId === "others") {
    return !segment;
  }

  return segment?.id === sectorId;
};
